export const comments_3249787 = {"data":{"data":[],"links":{}}}